import { http } from "./http";

/**
 * Arquivos do workspace do projeto.
 * REGRA: o frontend nunca acessa o filesystem — toda leitura/gravação passa
 * pela API autenticada, que valida o caminho dentro do workspace.
 */

export interface WorkspaceEntry {
  path: string;
  type: "file" | "directory";
  size: number;
  modified_at: number;
}

export interface FileContents {
  path: string;
  contents: string;
  size: number;
  is_binary: boolean;
  hash: string;
}

export interface OriginalContents {
  path: string;
  ref: string;
  exists: boolean;
  contents: string;
}

export const fileService = {
  list: (project: string) => http.get<WorkspaceEntry[]>(`/projects/${project}/files`),

  read: (project: string, path: string) =>
    http.get<FileContents>(`/projects/${project}/file?path=${encodeURIComponent(path)}`),

  /** Versão do arquivo no último commit — lado "ANTES" do diff. */
  original: (project: string, path: string, ref = "HEAD") =>
    http.get<OriginalContents>(
      `/projects/${project}/file/original?path=${encodeURIComponent(path)}&ref=${encodeURIComponent(ref)}`,
    ),

  create: (project: string, path: string, contents = "") =>
    http.post<FileContents>(`/projects/${project}/files`, { path, contents }),

  createDirectory: (project: string, path: string) =>
    http.post<{ path: string }>(`/projects/${project}/files`, { path, type: "directory" }),

  save: (project: string, path: string, contents: string) =>
    http.put<FileContents>(`/projects/${project}/files`, { path, contents }),

  move: (project: string, from: string, to: string) =>
    http.post<{ path: string }>(`/projects/${project}/files/move`, { from, to }),

  remove: (project: string, path: string) =>
    http.delete<{ deleted: string }>(`/projects/${project}/files`, { path }),

  /** Checkpoint manual do Git — nunca automático a cada gravação. */
  checkpoint: (project: string, description: string) =>
    http.post<{ uuid: string; number: number; git_commit: string | null }>(
      `/projects/${project}/versions`,
      { description, source: "user" },
    ),
};
